import { useEffect, useState } from "react";

const navItems = [
  { href: "#tournee", label: "Tournée" },
  { href: "#presse", label: "Dossier de presse" },
  { href: "#affiche", label: "Affiche" },
  { href: "#qui-sommes-nous", label: "Qui sommes nous ?" },
  { href: "#propagande", label: "Propagande" },
  { href: "#contact", label: "Contact" },
];

export function Header() {
  const [isOpen, setIsOpen] = useState(false);

  useEffect(() => {
    if (!isOpen) {
      return;
    }

    const handleKeyDown = (event: KeyboardEvent) => {
      if (event.key === "Escape") {
        setIsOpen(false);
      }
    };

    document.addEventListener("keydown", handleKeyDown);
    document.body.classList.add("nav-open");

    return () => {
      document.removeEventListener("keydown", handleKeyDown);
      document.body.classList.remove("nav-open");
    };
  }, [isOpen]);

  const closeMenu = () => {
    setIsOpen(false);
  };

  return (
    <header className="topbar" aria-label="Navigation principale">
      <div className="topbar-row">
        <a className="brand" href="#accueil" aria-label="Accueil">
          Les Apprentis Dictateurs
        </a>
        <button
          aria-controls="main-nav"
          aria-expanded={isOpen}
          aria-label={isOpen ? "Fermer le menu" : "Ouvrir le menu"}
          className="menu-toggle"
          onClick={() => setIsOpen((open) => !open)}
          type="button"
        >
          <span aria-hidden="true">{isOpen ? "✕" : "☰"}</span>
        </button>
      </div>
      {isOpen && (
        <button
          aria-label="Fermer le menu"
          className="nav-backdrop"
          onClick={closeMenu}
          type="button"
        />
      )}
      <nav className={`nav-links ${isOpen ? "nav-links-open" : ""}`} id="main-nav">
        {navItems.map((item) => (
          <a key={item.href} href={item.href} onClick={closeMenu}>
            {item.label}
          </a>
        ))}
      </nav>
    </header>
  );
}
